<template>
  <div>
    <v-layout fill-height>
      <v-flex fill-height class="header d-flex flex-column">
        <m-loader-dialog v-model="loaderDialog"></m-loader-dialog>
        <table class="tablestriped">
          <thead>
            <tr>
              <th>Nom du catalogue</th>
              <th>Date de création</th>
              <th>Template</th>
              <th>Nombre de produits</th>
              <th>Nombre de pages</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              @click="openCatalog(catalog.ca_id)"
              v-for="(catalog,index) in catalogs"
              :key="index"
              class="withpointer"
            >
              <td>{{catalog.ca_name}} - {{catalog.ca_lang | uppercase}}</td>
              <td>Le {{$moment(catalog.createdAt).format("DD MMMM YYYY") }}</td>
              <td>{{getTemplateName(catalog)}}</td>
              <td>{{catalog.ca_nb_products}}</td>
              <td>{{catalog.ca_nb_pages}}</td>
              <td class="d-flex flex-row">
                <v-toolbar-items v-if="$store.state.myrights.create_catalogue">
                  <v-menu :open-on-hover="true" :offset-y="true">
                    <template v-slot:activator="{ on }">
                      <div
                        v-on="on"
                        class="ml-3 withpointer"
                        @click.stop="actionWinConfirm(catalog.ca_id, catalog.ca_name, true, false, false)"
                      >
                        <icon class="mr-2" name="trash"></icon>
                      </div>
                    </template>
                    <div class="dropdown-aide">
                      <div class>Supprimer</div>
                    </div>
                  </v-menu>
                </v-toolbar-items>
                <v-toolbar-items v-if="$store.state.myrights.create_catalogue">
                  <v-menu :open-on-hover="true" :offset-y="true">
                    <template v-slot:activator="{ on }">
                      <div
                        v-on="on"
                        class="ml-3 withpointer"
                        @click.stop="actionWinConfirm(catalog.ca_id,catalog.ca_name, false, true, false)"
                      >
                        <icon class="mr-2" name="copy"></icon>
                      </div>
                    </template>
                    <div class="dropdown-aide">
                      <div class>Dupliquer</div>
                    </div>
                  </v-menu>
                </v-toolbar-items>
                <v-toolbar-items v-if="$store.state.myrights.create_catalogue">
                  <v-menu :open-on-hover="true" :offset-y="true">
                    <template v-slot:activator="{ on }">
                      <div
                        v-on="on"
                        class="ml-3 withpointer"
                        @click.stop="actionWinConfirm(catalog.ca_id,catalog.ca_name, false, false, true, catalog.ca_archived)"
                      >
                        <icon class="mr-2" :name="catalog.ca_archived?'box-open':'archive'"></icon>
                      </div>
                    </template>
                    <div class="dropdown-aide">
                      <div class>{{catalog.ca_archived?'désarchiver':'archiver'}}</div>
                    </div>
                  </v-menu>
                </v-toolbar-items>
              </td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </v-layout>
    <m-confirm-dialog
      v-model="confirmActionCatalog"
      :text="`Souhaitez-vous vraiment ${textWinConfirm} ce catalogue :  ${catalogNameToAction} ?`"
      title="Confirmation"
      @canceled="confirmActionCatalog=false"
      @confirmed="actionGo()"
    ></m-confirm-dialog>
  </div>
</template>

<script>
export default {
  name: "catalogs-list",
  components: {},
  props: { showArchive: Boolean },
  data() {
    return {
      catalogs: [],
      confirmActionCatalog: false,
      deleteCatalog: false,
      catalogIdToAction: null,
      catalogNameToAction: "",
      textWinConfirm: "",
      ca_archived: true,
      copyCatalog: false,
      loaderDialog: false
    };
  },
  watch: {
    async showArchive(val) {
      this.loadCatalogs();
    }
  },
  mounted() {
    this.loadCatalogs();
  },
  destroyed() {},
  methods: {
    getTemplateName(catalog) {
      // return catalog.ca_template;
      if (catalog.ca_template * 1 == 1) return "PDF";
      if (catalog.ca_template * 1 == 2) return "Excel";
      if (catalog.ca_template * 1 == 4) return "PDF maison";
      return "---";
    },
    openCatalog(ca_id) {
      this.$router.push("/catalogs/edit/" + ca_id);
    },
    async loadCatalogs() {
      this.loaderDialog = true;
      let params = {
        archived: this.showArchive,
        sort: "createdAt desc"
      };
      let response = await this.$axios.get(
        this.$config.server_url + "/api/1.0/catalogs",
        { params }
      );
      this.catalogs = response.data.data;
      this.loaderDialog = false;
      this.$emit("catalogsLoaded", this.catalogs.length);
    },
    actionWinConfirm(
      ca_id,
      name,
      deleteCatalog,
      copyCatalog,
      archiveCatalog,
      ca_archived = null
    ) {
      this.catalogNameToAction = name;
      this.catalogIdToAction = ca_id;
      this.copyCatalog = copyCatalog;
      this.deleteCatalog = deleteCatalog;
      this.archiveCatalog = archiveCatalog;
      // if (!copyCatalog) this.copyCatalog = false;
      // if (deleteCatalog) this.deleteCatalog = true;
      // if (!deleteCatalog) this.deleteCatalog = false;
      // if (deleteCatalog) this.textWinConfirm = "supprimer";

      if (copyCatalog) {
        this.textWinConfirm = "copier";
      }
      if (deleteCatalog) {
        this.textWinConfirm = "supprimer";
      }
      if (archiveCatalog) {
        this.ca_archived = !ca_archived;
        if (ca_archived) {
          this.textWinConfirm = "désarchiver";
        } else {
          this.textWinConfirm = "archiver";
        }
      }
      this.confirmActionCatalog = true;
    },
    async actionGo() {
      this.loaderDialog = true;
      if (this.copyCatalog) {
        await this.$axios.get(
          this.$config.server_url + "/api/1.0/matrice/duplicate",
          {
            params: {
              ca_id: this.catalogIdToAction,
              duplicatecatalog: true
            }
          }
        );
      }
      if (this.deleteCatalog) {
        await this.$axios.delete(
          this.$config.server_url +
            "/api/1.0/catalogs/" +
            this.catalogIdToAction
        );
      }
      if (this.archiveCatalog) {
        await this.$axios.put(
          this.$config.server_url +
            "/api/1.0/catalogs/" +
            this.catalogIdToAction,
          { ca_archived: this.ca_archived }
        );
      }
      this.confirmActionCatalog = false;
      // this.catalogIdToAction = null;
      // this.catalogNameToAction = "";
      this.loadCatalogs();
    }
  }
};
</script>
<style lang="scss" scoped>
thead > tr > th {
  font-size: 13px;
  text-transform: uppercase;
  font-weight: 700;
}
.dropdown-aide {
  background-color: #fff;
  padding: 5px;
}
</style>